import React from 'react';

import '../../assets/css/Loader.css';


/**
 * Componente funcional `Loading`.
 *
 * Este componente muestra una superposición de carga con un spinner y un mensaje
 * cuando la propiedad `isLoading` es `true`. Si `isLoading` es `false`, el componente
 * no renderiza nada.
 *
 * @param {Object} props - Las propiedades del componente.
 * @param {boolean} props.isLoading - Indica si el componente debe mostrarse o no.
 * @param {string} [props.title='Loading...'] - El texto que se muestra debajo del spinner.
 *
 * @returns {JSX.Element|null} - Devuelve el contenido del componente si `isLoading` es `true`,
 * o `null` si es `false`.
 */
const Loading = ({isLoading, title='Loading...', showTitle = true}) => {
    if (!isLoading) return null;


    return <>
        <div className="loading-overlay">
            <div className="spinner-border text-primary" role="status"></div>
            <br/>
            { showTitle && <span>{title}</span> }
        </div>
    </>
}

export default Loading;